<template>
  <ul :class="{
    'menu-list': type === 'pc',
    'menu_cards': type === 'mobile',
    '_mobile-menu-cards': type === 'mobile'
  }">
    <li><router-link :class="{ active: section === '/journal' }" to="/journal">Журнал</router-link></li>

    <template v-if="invType">
      <template v-if="invType === 1">
        <li>
          <router-link :class="{ active: section === '/investments' }" to="/investments">
            Инвестиции
          </router-link>
        </li>
      </template>
      <template v-else>
        <li>
          <router-link :class="{ active: section === '/landing-invest' }" to="/landing-invest">
            Инвестиции
          </router-link>
        </li>
      </template>
    </template>

    <template v-else>
      <li><router-link to="/login-invest">Инвестиции</router-link></li>
    </template>

    <li>
      <router-link :class="{ active: section === '/consultations' }" to="/consultations">Консультации</router-link>
    </li>
  </ul>
</template>
<script>
export default {
  props: {
    type: String,
  },
  data: () => {
    return { section: null }
  },
  watch: {
    $route(to, from) {
      if (to.path) {
        this.setSection(to.path);
      } else {
        this.setSection(null);
      }
    }
  },
  computed: {
    invType() {
      return this.$store.state.user?.payment?.inv_type;
    }
  },
  mounted() {
    this.setSection(this.$route.path)
  },
  methods: {
    setSection(newSection) {
      if (newSection === '/' || newSection === '/dev') {
        this.section = null;
      } else {
        this.section = newSection;
      }
    },
  }
}
</script>

<style scoped lang="scss">

html.__redesign .new-journal .menu-redesign {
  ul.menu-list {
    li {
      a:active {
        color: aqua;
      }
    }
  }
}
</style>
